import { Link } from "react-router-dom";
import F1 from "../assets/1.png";
import F2 from "../assets/2.png";
import F3 from "../assets/3.png";
import F4 from "../assets/4.png";

const NuestrosServicios = () => {
	const services = [
		{ name: "Prestadora de servicios", src: F1 },
		{ name: "Consultoría en Gestión Empresarial", src: F2 },
		{ name: "Renta de Hidrolavadoras y Fumigadoras", src: F3 },
		{ name: "Mantenimiento y Limpieza Industrial", src: F4 },
	];

	return (
		<div>
			<h2 className="text-center text-3xl font-semibold">
				{" "}
				Nuestros servicios{" "}
			</h2>
			<div className="h-[75vh] grid grid-cols-2 md:grid-cols-4 p-4 md:p-12 gap-4">
				{services.map((service, index) => (
					<Link
						to="/services"
						key={index}
						className="relative group h-full md:h-full overflow-hidden shadow-lg"
					>
						<div
							className="absolute inset-0 bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
							style={{ backgroundImage: `url(${service.src})` }}
						></div>
						<div className="absolute inset-0 bg-black/50 group-hover:bg-black/30 transition-colors duration-500"></div>
						<div className="relative z-10 flex items-center justify-center h-full w-full">
							<span className="text-white text-center text-sm md:text-lg font-semibold px-4">
								{service.name}
							</span>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default NuestrosServicios;
